const toUSD2 = (value) => {
  if (value) {
    return `$ ${value.toLocaleString(undefined,
      { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
  }
  return '$ 0.00';
};

export default toUSD2;
